import { GetPatientDocuments } from 'domain/usecases/patient/get-patient-documents'
import { PatientDocumentRepository } from 'repository/interfaces/patient-document-repository'

export class RemoteGetPatientDocuments implements GetPatientDocuments {
  constructor(
    private readonly patientDocumentRepository: PatientDocumentRepository
  ) {}

  get(params: GetPatientDocuments.Params): Promise<GetPatientDocuments.Model> {
    return this.patientDocumentRepository.getPatientDocuments(params)
  }
}

export type GetPatientDocumentsModel = GetPatientDocuments.Model
